import { IColumn } from "../../../models";

export const caregiver: IColumn = {
  A: {
    key: "firstName",
    valueType: "string",
    validationTypes: ["empty"],
    columnText: "First Name",
  },
  B: {
    key: "lastName",
    valueType: "string",
    validationTypes: ["empty"],
    columnText: "Last Name",
  },
  C: {
    key: "userName",
    valueType: "string",
    validationTypes: ["empty", "unique"],
    columnText: "User Name (unique)",
  },
  D: {
    key: "password",
    valueType: "string",
    validationTypes: ["empty", "password"],
    columnText: "Password",
  },
  E: {
    key: "gender",
    valueType: "string",
    validationTypes: ["empty", "gender"],
    columnText: "Gender",
  },
  F: {
    key: "dateOfBirth",
    valueType: "date",
    validationTypes: ["empty", "date"],
    columnText: "Date of Birth (mm/dd/yyyy)",
  },
  G: {
    key: "phoneNumber",
    valueType: "string",
    validationTypes: ["empty"],
    columnText: "Phone Number",
  },
  H: {
    key: "email",
    valueType: "string",
    validationTypes: ["empty", "unique", "email"],
    columnText: "Email (unique)",
  },
  I: {
    key: "ssn",
    valueType: "string",
    validationTypes: ["empty", "unique"],
    columnText: "Social security number (unique)",
  },
  J: {
    key: "champsIdNo",
    valueType: "string",
    validationTypes: ["empty"],
    columnText: "Champs Id",
  },
  K: {
    key: "rate",
    valueType: "number",
    validationTypes: ["empty", "number"],
    columnText: "Rate",
  },
  L: {
    key: "address",
    valueType: "string",
    validationTypes: ["empty", "address"],
    columnText: "Address",
  },
  M: {
    key: "apartmentNumber",
    valueType: "string",
    validationTypes: [],
    columnText: "Apartment",
  },
  N: {
    key: "monday",
    valueType: "day",
    value: "Monday",
    validationTypes: ["empty", "yes_no"],
    columnText: "Is Available on Monday? (Yes/No)",
  },
  O: {
    key: "tuesday",
    valueType: "day",
    value: "Tuesday",
    validationTypes: ["empty", "yes_no"],
    columnText: "Is Available on Tuesday? (Yes/No)",
  },
  P: {
    key: "wednesday",
    valueType: "day",
    value: "Wednesday",
    validationTypes: ["empty", "yes_no"],
    columnText: "Is Available on Wednesday? (Yes/No)",
  },
  Q: {
    key: "thursday",
    valueType: "day",
    value: "Thursday",
    validationTypes: ["empty", "yes_no"],
    columnText: "Is Available on Thursday? (Yes/No)",
  },
  R: {
    key: "friday",
    valueType: "day",
    value: "Friday",
    validationTypes: ["empty", "yes_no"],
    columnText: "Is Available on Friday? (Yes/No)",
  },
  S: {
    key: "saturday",
    valueType: "day",
    value: "Saturday",
    validationTypes: ["empty", "yes_no"],
    columnText: "Is Available on Saturday? (Yes/No)",
  },
  T: {
    key: "sunday",
    valueType: "day",
    value: "Sunday",
    validationTypes: ["empty", "yes_no"],
    columnText: "Is Available on Sunday? (Yes/No)",
  },
  U: {
    key: "allTimeAvailability",
    valueType: "boolean",
    validationTypes: ["empty", "yes_no"],
    columnText: "Is Available for 24 hours? (Yes/No)",
  },
  V: {
    key: "availableFrom",
    valueType: "date-time",
    validationTypes: ["time"],
    columnText: "Available From (hh:mm:ss)",
  },
  W: {
    key: "availableTo",
    valueType: "date-time",
    validationTypes: ["time"],
    columnText: "Available To (hh:mm:ss)",
  },
  X: {
    key: "isTransportAvailable",
    valueType: "boolean",
    validationTypes: ["empty", "yes_no"],
    columnText: "Is Transport Available? (Yes/No)",
  },
  Y: {
    key: "gpsCheckInTurnedOn",
    valueType: "boolean",
    validationTypes: ["empty", "yes_no"],
    columnText: "Is GPS Available? (Yes/No)",
  },
  Z: {
    key: "autoClockCheckIn",
    valueType: "boolean",
    validationTypes: ["empty", "yes_no"],
    columnText: "Is Autoclock Enabled? (Yes/No)",
  },
};

export const caregiverRequiredColumn = Object.values(caregiver).filter(
  (column) => column.validationTypes.includes("empty")
);
